var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigmaFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "url(#pattern0_250_462)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_250_462",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_250_462",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_250_462",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADn0lEQVR4nO3dzW7TQBQF4JMX4a+sC23Z8c8LFAg/b1NSeK62UhSKeIC0oU8AtBtIF4XNQSMNUuQx4ATPnXun91uy6LFnZDl4fDyAc845ZxDJTZK7JA9IHpM854pa/vaqzuOx7Mdj20TNSA5IviA5Y4+Q5vQpTNAwHDtqQvI6yUNmgDQrh/ckr6EGJO+S/JJpoNiSl8sZycewjOQDkj8yDhJbMnMK53IfFoVLPOeV8VtLbm7hSrkBgzfwLPeMppZsCRNYQvKl0MCwJVvKcxi6Onr9afs3LflSjmAByS3BQWFLvqTb0I7kW8kRQZovaQTt4uMQMUjzJe1BO5InkiOCNF/SDNqRnEuOCNJ8SXNoR/K75IggzZf0DdqR/CQ5IkjzJR1Du7ieIAZpviQTN/WR5IggzZe0A+1IbkiOCNJ8Sesw8ugkrLSJQJovZQor4rKnCKTZUrZhRbxKwrJndkizJYxhDcmrvkClTFjurGwJ94LkPVTwksPnXCOENC+XU5KPUIO4vj7JMUpIs3IYk7yC2oRlz7DS1udIIc3o05TkU9QurLSRfBMePcT/s8xXHbGWv72qeTyWvXhs+lcDnXPOuZr7IR0f62zFt2MO4jtk5wv9kPBv3g9Z1ZIT8WrJFc1Z7LR4P6SrjpOxRvIjV/chdFxQA+l+SFN49tRTfnjr/QksK9EPWRQKNiR/9hgXzuUhLCrVD2nU6L5miAxXyk1YUrIfspD/P/eMfzk0daMv2Q8JSL4WiB7CAgX9kIHQy3r6X5JT0g+5Ixi/Ae0U9EPeCcZ7P6TDhEj2U0y8Slq6H3IiGO/9kA4TItlP8X5IhwmR7Kd4P6TDhEj2U/T/9FXQD9kXjDdxUy/dD9kVjPd+SIcJCauRUm5BOwX9kIHQoxsbn9Yo3Q8J4rJrbs9gRcl+yEJ+WHbNZWLq8XvJfkhjgSzXAtUaLCrRD1kUllt7zrf7ib9S/ZCML1nY/whmiX5Ips/UTqr5TKx0P+RP4o1+uORP8iMzn/LT2g9Z4uMGo0a+90Occ845S/0QJ7x/iFO2f4hT3g9xivohTlE/xCnqhzhl/RCnqB/ilPVDnLJ+iFO2f4hT1g9xyvYPcQ3ez1DG+xnKeD/jcvdDdkqfr3rC+4eslz5f9QT7IdPS52qGUD9ku/R5miHQDxmXPkdzMvZDzsxtMF9xP+TC/P4dFfVDTqvZv6OCfsi4yv07DPZDppdi/w6l/ZC579/hnHPOYWm/AK86/NY339oXAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaFill);
export default __webpack_public_path__ + "static/media/figma-fill.2f88b012e0bd07bce954b2ecd297024e.svg";
export { ForwardRef as ReactComponent };